import {useCallback} from 'react';
import {
  BaseEventData,
  trackBubbleMessageSent,
  trackBubbleQRClick,
  trackMessageSent,
  trackQRClick,
  trackReservationSubmitted, trackVehicleDetailsButtonClicked,
  trackVehicleViewed
} from '../../features/gtmTracking';
import {botIdSelector, pageFullUrlSelector, websiteLocationSelector} from '../../features/chatbotSlice';
import {getUtmParameters} from '../../features/chatbotUtil';
import {useAppSelector} from '../hooks';

export const useGTMTracking = () => {
  const botId = useAppSelector(botIdSelector);
  const websiteLocation = useAppSelector(websiteLocationSelector);
  const fullUrl = useAppSelector(pageFullUrlSelector);

  const getBaseData = useCallback((): BaseEventData => ({
    botId: botId || '',
    pageUrl: fullUrl || window.location.href,
    timestamp: Date.now(),
    ...getUtmParameters()
  }), [botId, fullUrl]);

  return {
    messageSent: useCallback((userMessage: string) => {
      trackMessageSent(getBaseData(), userMessage, userMessage.length, websiteLocation);
    }, [getBaseData, websiteLocation]),

    bubbleMessageSent: useCallback((userMessage: string) => {
      trackBubbleMessageSent(getBaseData(), userMessage, userMessage.length, websiteLocation);
    }, [getBaseData, websiteLocation]),

    qrClick: useCallback((qrLabel: string) => {
      trackQRClick(getBaseData(), qrLabel, websiteLocation);
    }, [getBaseData, websiteLocation]),

    bubbleQRClick: useCallback((qrLabel: string) => {
      trackBubbleQRClick(getBaseData(), qrLabel, websiteLocation);
    }, [getBaseData, websiteLocation]),

    vehicleViewed: useCallback((vehicleId: string) => {
      trackVehicleViewed(getBaseData(), vehicleId, websiteLocation);
    }, [getBaseData, websiteLocation]),

    reservationSubmitted: useCallback((reservedVin: string) => {
      trackReservationSubmitted(getBaseData(), {vin: reservedVin}, websiteLocation);
    }, [getBaseData, websiteLocation]),

    vehicleDetailsButtonClicked: useCallback((buttonText: string, buttonAction: string) => {
      trackVehicleDetailsButtonClicked(getBaseData(), buttonText, buttonAction, websiteLocation);
    }, [getBaseData, websiteLocation])
  };
};
